export const agent = {
  header: {
    title: 'Sergeo',
    subtitle: 'Your Referent data, on demand.',
    recentChats: 'Recent chats',
    noChats: 'No previous chats.',
    untitled: 'Untitled',
  },
  chat: {
    heading: 'How can I help?',
    description: 'Ask me anything about your Referent account.',
    placeholder: 'Ask Sergeo...',
    suggestions: {
      brandVoices: 'Show me my brand voices',
      contentStats: 'How much content have I created?',
      changeLanguage: 'Change my language',
    },
  },
  sessions: {
    newChat: 'New Chat',
    noConversations: 'No conversations yet',
    untitled: 'Untitled',
  },
  workflows: {
    title: 'Custom Workflows',
    subtitle: 'Automate recurring tasks',
    comingSoon: 'Coming Soon',
    createContent: 'Create Content',
    createContentDesc: 'Generate a new article or blog post',
    createContentPrompt: 'I want to create a new content piece',
    seoAudit: 'SEO Audit',
    seoAuditDesc: 'Analyze on-page SEO factors',
    contentBrief: 'Content Brief Generator',
    contentBriefDesc: 'Create structured content briefs',
    competitorAnalysis: 'Competitor Analysis',
    competitorAnalysisDesc: 'Compare against competitors',
    brandVoiceCheck: 'Brand Voice Check',
    brandVoiceCheckDesc: 'Validate tone consistency',
    contentRepurposer: 'Content Repurposer',
    contentRepurposerDesc: 'Transform existing content',
  },
  tools: {
    running: 'Running {{tool}}...',
    brandVoices: {
      empty: 'No brand voices found.',
      title: 'Brand Voices ({{count}})',
    },
    contentStats: {
      empty: 'No content yet.',
      title: 'Content Stats',
      total: '{{count}} total',
    },
    gsc: {
      title: 'Google Search Performance',
      last28Days: 'Last 28 days',
      emptyTitle: 'No recent search data',
      emptyDescription: 'This page has no recent Google Search Console data for the selected range.',
      outsideProperty: 'URL outside connected property',
      topQueries: 'Top queries',
      metrics: {
        clicks: 'Clicks',
        impressions: 'Impressions',
        ctr: 'CTR',
        position: 'Avg. position',
      },
    },
    language: {
      failed: 'Failed to change language from {{from}} to {{to}}.',
      changed: 'Language changed from',
      to: 'to',
    },
    framer: {
      addItemTitle: 'CMS item created',
      addItemMessage: 'New item added to the Framer collection.',
      addItemHint: 'Run publish to deploy the preview.',
      addItemIdLabel: 'Item ID',
      publishTitle: 'Preview deployed',
      publishMessage: 'Preview deployment created successfully.',
      publishOpenDashboard: 'Check the Framer dashboard to view it.',
      publishPreview: 'Preview',
      publishOpenPreview: 'Open preview',
      publishDeploymentIdLabel: 'Deployment ID',
    },
  },
  errors: {
    generic: 'Something went wrong. Please try again.',
  },
  time: {
    justNow: 'just now',
    minutesAgo: '{{count}}m ago',
    hoursAgo: '{{count}}h ago',
    daysAgo: '{{count}}d ago',
    weeksAgo: '{{count}}w ago',
    monthsAgo: '{{count}}mo ago',
  },
} as const
